// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"1bddb6d4","798":"ee6c5929","956":"5d5b2af0"}[chunkId] + ".chunk.js";
};